import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  font-style: italic;
`
